export type RunNoticePriority = 'info' | 'action' | 'danger' | 'critical';

const priorityRank: Record<RunNoticePriority, number> = {
  info: 0,
  action: 1,
  danger: 2,
  critical: 3,
};

/**
 * Owns the lease on the large in-field instruction surface. Match snapshots
 * can contain several events at once, so a later world update must not erase
 * a local knockout, broken bank link, or other urgent recovery instruction.
 */
export class RunNoticeArbiter {
  private priority: RunNoticePriority | null = null;
  private expiresAt = 0;
  private context: string | null = null;

  public request(priority: RunNoticePriority, durationMilliseconds: number, now: number, context?: string): boolean {
    if (this.priority && now < this.expiresAt && priorityRank[priority] < priorityRank[this.priority]) return false;
    this.priority = priority;
    this.expiresAt = now+Math.max(0, durationMilliseconds);
    this.context = context ?? null;
    return true;
  }

  public hold(priority: RunNoticePriority): void {
    this.priority = priority;
    this.expiresAt = Number.POSITIVE_INFINITY;
    this.context = null;
  }

  /** End only the warning owned by this state, never a newer critical notice. */
  public release(context: string): boolean {
    if (this.context !== context) return false;
    this.clear();
    return true;
  }

  public active(now: number): boolean {
    return this.priority !== null && now < this.expiresAt;
  }

  public clear(): void {
    this.priority = null;
    this.expiresAt = 0;
    this.context = null;
  }
}
